import React from 'react';
import { StyleProps } from '@summer/react-kit';
import { RangeFilter } from 'src/app/common/models/filter';
import { ConnectedCommonRangeFilter } from 'src/app/search/components/SearchPanel/CommonRangeFilter';

export const SearchRimSizeAppearanceFilter = (props: StyleProps) => (
  <ConnectedCommonRangeFilter kind={RangeFilter.RimSize} {...props} />
);
